import { Component, OnInit } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { PaymentService } from '../../services/payment.service';
import { map, switchMap, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { PaymentTypeEnum } from '../../models/payment-type.model';
import { CurrencyPipe } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-wire-transfer',
  templateUrl: './wire-transfer.component.html',
  styleUrls: ['./wire-transfer.component.scss'],
  providers: [CurrencyPipe]
})
export class WireTransferComponent implements OnInit {
  data: Observable<WireTransferDetails>;

  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private currency: CurrencyPipe,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar
  ) {
    this.data = this.route.data.pipe(
      switchMap(data =>
        combineLatest([
          of(data),
          this.paymentService.createWireTransferTransaction(data.paymentType, null, null, 'test@email.com')
        ])
      ),
      map(([data, ban]) => ({
        transferDetails: [
          { label: 'Numer rachunku', value: ban },
          {
            label: 'Kwota',
            value: `${this.getAmount(data.paymentType)} zł`,
            copyValue: this.getAmount(data.paymentType)
          },
          { label: 'Dane odbiorcy', value: 'ING Usługi Dla Biznesu S.A. ul. Chorzowska 50, 40‑121 Katowice' },
          { label: 'Tytuł', value: this.getTitle(data.paymentType) }
        ],
        bankDetails: [
          { label: 'Bank', value: 'ING Bank Śląski' },
          { label: 'SWIFT', value: 'INGBPLPW' },
          { label: 'Sort code', value: '11401124' }
        ],
        bankDetailsVisible: false,
        biller: this.paymentService.payment.biller
      }))
    );
  }

  private getAmount(paymentType: PaymentTypeEnum): string {
    return (paymentType === PaymentTypeEnum.LIABILITY
      ? this.paymentService.payment.amountToPay
      : this.paymentService.payment.balance.amountToPay
    )
      .toFixed(2)
      .replace('.', ',');
  }

  ngOnInit(): void {}

  private getTitle(paymentType: PaymentTypeEnum) {
    return `${paymentType === PaymentTypeEnum.LIABILITY ? this.paymentService.payment.title : 'Spłata salda'} / ${
      this.paymentService.payment.biller
    }`;
  }

  copy(value: string) {
    this.clipboard.copy(value);
    this.snackBar.open('Skopiowano informacje do schowka.', null, {
      verticalPosition: 'top',
      duration: 3000
    });
  }
}

interface WireTransferDetails {
  transferDetails: Item[];
  bankDetails: Item[];
  bankDetailsVisible: boolean;
  biller: string;
}

interface Item {
  label: string;
  value: string | SafeHtml;
  copyValue?: string;
}
